import React, { useEffect, useState, useRef } from "react"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  FormGroup,
  Form,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"

import "./datatables.scss"
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";


const DatatableTables = props => {
  document.title = "Batch Details | My Urban Farms"
  const adminKey = sessionStorage.getItem("pk_admin_key");

  const breadcrumbItems = [
    // { title: "Batch Details", link: "#" },
  ]
  const [modal_center, setmodal_center] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)
  const [batchList, setBatchList] = useState([])
  const [farmList, setFarmList] = useState([])
  const [selectedFarm, setSelectedFarm] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [initialProcess, setInitialProcess] = useState("");
  const [sequenceKey, setSequenceKey] = useState("");
  const [processKey, setProcessKey] = useState("");
  const toggleDropdown = id => {
    setOpenDropdown(openDropdown === id ? null : id)
  }
  const [processList, setProcessList] = useState([]);
  const [bags, setBags] = useState([]);
  const [newStage, setNewStage] = useState("")
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedBag, setSelectedBag] = useState(null)
  const [sequenceList, setSequenceList] = useState([]);

  const [selectedFarmKey, setSelectedFarmKey] = useState("");




  function tog_center() {
    setmodal_center(!modal_center)
    if (modal_center) {
      formik.resetForm()
    }
  }

  const closeModal = () => {
    setmodal_center(false)
    formik.resetForm()
  }

  useEffect(() => {
    props.setBreadcrumbItems("Batch Details", breadcrumbItems)
    fetchFarms();

  }, [])


  const fetchSavedSequence = async (selectedFarmKey) => {
    try {
      const URL = `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`;
      const res = await axios.post(URL, { farmKey: selectedFarmKey });
      const seq = res.data?.message?.data?.data || [];

      const firstProcess = seq.find((p) => p.process_position === 1);

      if (firstProcess) {
        setInitialProcess(firstProcess.process_name);
        setSequenceKey(firstProcess.pk_sequence_key);
        setProcessKey(firstProcess.fk_process_key);
      }
    } catch (err) {
      console.error("Failed to fetch sequence:", err);
    }
  };

  const fetchFarms = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllFarms/farm/`
      );

      const resData = response.data;
      setIsLoading(false);

      if (resData.message?.success && Array.isArray(resData.message.data)) {
        setFarmList(resData.message.data);

        // Auto-select farm id=1 from list
        const defaultFarm = resData.message.data.find(f => f.pk_farm_id == 1);
        if (defaultFarm) {
          setSelectedFarmKey(defaultFarm.pk_farm_key);
        }
      } else {
        console.warn("Unexpected data format", resData);
        setFarmList([]);
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setIsLoading(false);
      setFarmList([]);
      toast.error("Failed to fetch!", { autoClose: 3000 });
    }
  };



  const fetchBatches = async (selectedFarmKey) => {
    if (!selectedFarmKey) {
      setBatchList([]);
      return;
    }
    setIsLoading(true)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllBatches/batch/`,
        { farmKey: selectedFarmKey }
      )
      const resData = response.data
      setIsLoading(false)

      if (resData.message?.success && Array.isArray(resData.message.data)) {
        setBatchList(resData.message.data)
      } else {
        console.warn("Unexpected data format", resData)
        setBatchList([]) // Set to empty array on unexpected format
      }
    } catch (error) {
      console.error("Failed to fetch batch list:", error)
      setIsLoading(false)
      setBatchList([])
      toast.error("Failed to fetch batches!", { autoClose: 3000 })
    }
  }

  useEffect(() => {
    formik.setFieldValue("initial_process", initialProcess);
  }, [initialProcess]);

  useEffect(() => {
    formik.setFieldValue("pk_sequence_key", sequenceKey);
    formik.setFieldValue("fk_process_key", processKey);
  }, [sequenceKey, processKey]);


  const fetchProcesses = async (selectedFarmKey) => {
    try {
      // 1. Fetch process list
      const processRes = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllProcess/process/`, { farmKey: selectedFarmKey}
      );
      const processList = processRes.data?.message?.data || [];

      // 2. Fetch process sequence
      const seqRes = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`, { farmKey: selectedFarmKey}
      );
      const sequenceList = seqRes.data?.message?.data?.data || [];

      // 3. Merge: attach position to each process
      const merged = processList.map(proc => {
        const seq = sequenceList.find(s => s.fk_process_key === proc.pk_process_key);

        return {
          ...proc,
          process_position: seq ? seq.process_position : null, // if not found → null
        };
      });

      // 4. Save combined list
      setProcessList(merged);
    } catch (err) {
      console.error("Failed to load processes", err);
    }
  };

  useEffect(() => {
    if (!selectedBag?.id) return;   // id = pk_batch_key

    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/getBagsByBatch/batch`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ fk_batch_key: selectedBag.id }),
          }
        );

        const data = await res.json();
        console.log("API RESP", data);

        const bagsArray =
          data?.success === 1 &&
            data?.bags?.data?.bags &&
            Array.isArray(data.bags.data.bags)
            ? data.bags.data.bags
            : [];

        const formatted = bagsArray.map(b => ({
          pk_bag_manage_key: b.pk_bag_manage_key,
          id: b.bag_num,
          bagKey: b.bag_key,
          batchId: b.batch_num,
          processKey: b.fk_process_key,
          processSeqKey: b.fk_process_seq_key,
          batchName: b.batch_name,
          currentStage: b.current_stage,
          startDateDate: b.process_date,
          startDate: b.process_created_on,
          processDuration: b.process_duration,
          status: "In-Progress",
          qr_image: b.qr_image,
          processImage: b.process_image
            ? `${process.env.REACT_APP_IMAGE_URL}/${b.process_image}`
            : null,
        }));

        setBags(formatted);
      } catch (error) {
        console.error("Failed to load bags", error);
      }
    })();

  }, [selectedBag]);



  function getIndianDate() {
    const date = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata"
    });

    return new Date(date).toISOString().slice(0, 10);
  }

  const handleStageChange = async () => {
    if (!selectedBag?.id || !newStage) {
      toast.error("Please select a stage");
      return;
    }

    const payload = {
      fk_batch_key: selectedBag.id,   // This is the pk_batch_key
      fk_process_key: newStage.pk_process_key,
      fk_process_seq_key: newStage.pk_sequence_key,
      process_name: newStage.process_name,
      process_date: getIndianDate(),
      status: "1",
      created_by: adminKey,
      fk_farm_key: selectedFarmKey,



    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/changeBulkProcess/bag/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const result = await res.json();

      if (result?.success === true || result?.message?.success === true) {
        toast.success("Stage updated for all bags!");
        setModalOpen(false);
        fetchBatches(selectedFarmKey);
      } else {
        toast.error(result?.message?.message || "Failed to update stage");
      }

    } catch (err) {
      console.error(err);
      toast.error("Network error while updating stage");
    }
  };



  const formik = useFormik({
    initialValues: {
      batch_name: "",
      batch_number: "",
      bags_count: 0,
      created_date: "",
      process_start_date: "",
      initial_process: "",
      pk_sequence_key: "",
      fk_process_key: "",
      staff_name: "",
      seed_variety: "",
      supplier: "",

    },
    validationSchema: Yup.object({
      batch_name: Yup.string().required("Batch name is required"),
      // batch_number: Yup.string().required("Batch number is required"),
      batch_number: Yup.string()
        .required("Batch number is required")
        .test("unique-batch-number", "Batch number already exists", async function (value) {
          if (!value) return true; // allow other validators to handle empty

          try {
            const res = await axios.post(
              `${process.env.REACT_APP_API_BASE_URL}/checkBatchNum/batch/`,

              { batch_number: value, fk_farm_key: selectedFarmKey, }
            );

            const exists = res.data?.message?.data?.exists;
            return !exists; // return false → shows error
          } catch (error) {
            console.error("Error validating batch number:", error);
            return true; // avoid blocking form if API fails
          }
        }),

      bags_count: Yup.number()
        .min(1, "Must be at least 1 bag")
        .required("Number of bags is required"),
      created_date: Yup.string().required("Batch created date is required"),
      process_start_date: Yup.string().required("Process start date is required"),
      initial_process: Yup.string().required("Initial process is required"),
    }),
    onSubmit: async values => {
      const payload = {
        batch_name: values.batch_name,
        batch_number: values.batch_number,
        bags_count: values.bags_count,
        created_date: values.created_date,
        status: 1,
        created_by: adminKey,
        process_start_date: values.process_start_date,
        initial_process: values.initial_process,
        pk_sequence_key: values.pk_sequence_key,
        fk_process_key: values.fk_process_key,
        staff_name: values.staff_name,
        seed_variety: values.seed_variety,
        supplier: values.supplier,
        fk_farm_key: selectedFarmKey,

      }

      try {
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/addBatch/batch/`,
          payload
        )
        toast.success("Added successfully!", { autoClose: 3000 })
        fetchBatches(selectedFarmKey) // Refresh table data
        closeModal()
      } catch (error) {
        console.error("Error saving data:", error)
        toast.error("Error saving data!", { autoClose: 3000 })
      }
    },
  });

  const handleDeleteBatch = async (batchKey) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This batch will be marked inactive!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/deleteBatch/batch/`,
        { pk_batch_key: batchKey }
      );

      const backend = res?.data?.message?.data;

      if (backend?.success) {
        toast.success("Batch deleted successfully!", {
          autoClose: 3000,
        });
      } else {
        toast.error("Delete failed!", { autoClose: 3000 });
      }

      setOpenDropdown(null); // close dropdown
      fetchBatches(selectedFarmKey); // refresh list

    } catch (error) {
      console.error("Failed to delete batch:", error);
      toast.error("Error deleting batch!", { autoClose: 3000 });
    }
  };


  const openChangeStageModal = batch => {
    setSelectedBag(batch);
    setNewStage(null);
    setModalOpen(true);
    setOpenDropdown(null);
    fetchProcesses(selectedFarmKey);
  };


  const mappedRows = batchList.map((bag, index) => ({

    id: bag.pk_batch_key,
    sno: index + 1,
    batchname: bag.batch_name,
    batchNumber: bag.batch_num,
    bagsCount: `${bag.bags_count} Bags`,
    createdDate: bag.start_date,
    processStartedDate: bag.process_date,
    initialStage: bag.process_name,
    staffName: bag.staff_name,
    seedVariety: bag.seed_variety,
    supplier: bag.supplier,

  }))

  const data = {
    columns: [
      { label: "S.No", field: "sno", sort: "asc", width: 50 },
      // { label: "Batch Name", field: "batchname", sort: "asc", width: 150 },
      { label: "Batch Number", field: "batchNumber", sort: "asc", width: 150 },
      { label: "No. of Bags", field: "bagsCount", sort: "asc", width: 120 },
      { label: "Staff Incharge", field: "staffName", sort: "asc", width: 150 },
      { label: "Seed Variety", field: "seedVariety", sort: "asc", width: 150 },
      // { label: "Supplier", field: "supplier", sort: "asc", width: 150 },
      {
        label: "Batch Created Date",
        field: "createdDate",
        sort: "asc",
        width: 120,
      },
      // {
      //   label: "Initial Process Started Date",
      //   field: "processStartedDate",
      //   sort: "asc",
      //   width: 150,
      // },
      {
        label: "Current Stage",
        field: "initialStage",
        sort: "asc",
        width: 150,
      },
      { label: "Actions", field: "actions", sort: "disabled", width: 100 },
    ],
    rows: mappedRows.map(bag => ({
      ...bag,
      actions: (
        <Dropdown
          isOpen={openDropdown === bag.id}
          toggle={() => toggleDropdown(bag.id)}
        >
          <DropdownToggle
            tag="button"
            className="btn btn-link text-muted p-0 border-0 shadow-none"
          >
            <i className="mdi mdi-dots-vertical fs-5"></i>
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem>
              <Link
                to="/admin/bag-list"
                state={{ batchKey: bag.id, selectedFarmKey: selectedFarmKey }}
                className="text-dark text-decoration-none"
              >
                <i className="mdi mdi-eye-outline me-2"></i> View Details
              </Link>
            </DropdownItem>
            <DropdownItem onClick={() => openChangeStageModal(bag)}>
              <i className="mdi mdi-swap-horizontal me-2" ></i> Change Stage
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem className="text-danger" onClick={() => handleDeleteBatch(bag.id)}>
              <i className="mdi mdi-delete-outline me-2"></i> Delete Batch
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      ),
    })),
  }

  useEffect(() => {
    if (!selectedFarmKey) return;

    fetchSavedSequence(selectedFarmKey);
    fetchBatches(selectedFarmKey);
    fetchProcesses(selectedFarmKey);

  }, [selectedFarmKey]);

  return (
    <React.Fragment>
      <div className="d-flex align-items-center justify-content-between mb-3">

        {/* Left side: Breadcrumb + Farm Dropdown */}

        <Breadcrumb />




        {/* Right side: Add New Batch Button */}
        <div className="d-flex align-items-center">
          <div className="mt-2 me-3" style={{ minWidth: "250px" }}>
            <select
              className="form-select"
              value={selectedFarmKey}
              onChange={(e) => setSelectedFarmKey(e.target.value)}
            >
              <option value="">-- Select Farm --</option>
              {farmList.map((farm) => (
                <option key={farm.pk_farm_key} value={farm.pk_farm_key}>
                  {farm.farm_name}
                </option>
              ))}
            </select>
          </div>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light mt-2"
            onClick={() => {
              tog_center()
            }}
            data-toggle="modal"
            data-target=".bs-example-modal-center"
          >
            <i className="mdi mdi-plus me-1"></i>
            Add New Batch
          </Button>
        </div>
      </div>


      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <MDBDataTable
                responsive
                striped
                bordered
                data={data}
                noBottomColumns
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center()
        }}
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Create Batch</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row>
            <Col lg={12}>
              <Form onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  {" "}
                  <label htmlFor="example-text-input" className="form-label">
                    Batch Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="batch_name"
                    name="batch_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.batch_name}
                  />
                  {formik.touched.batch_name && formik.errors.batch_name ? (
                    <div className="text-danger mt-1">
                      {formik.errors.batch_name}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3">
                  {" "}
                  <label htmlFor="example-text-input" className="form-label">
                    Batch Number <span className="text-danger">*</span>
                  </label>
                  {/* <input
                    className="form-control"
                    type="text"
                    id="batch_number"
                    name="batch_number"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.batch_number}
                  /> */}
                  <input
                    className="form-control"
                    type="text"
                    id="batch_number"
                    name="batch_number"
                    value={formik.values.batch_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />


                  {formik.touched.batch_number && formik.errors.batch_number ? (
                    <div className="text-danger mt-1">
                      {formik.errors.batch_number}
                    </div>
                  ) : null}
                </div>


                <div className="mb-3">      <label
                  htmlFor="example-number-input"
                  className="form-label"
                >
                  Number of Bags <span className="text-danger">*</span>
                </label>

                  <input
                    className="form-control"
                    type="number"
                    id="bags_count"
                    name="bags_count"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bags_count}
                  />
                  {formik.touched.bags_count && formik.errors.bags_count ? (
                    <div className="text-danger mt-1">
                      {formik.errors.bags_count}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="example-date-input"
                    className="form-label"
                  >
                    Batch created date <span className="text-danger">*</span>
                  </label>

                  <input
                    className="form-control"
                    type="date"
                    id="created_date"
                    name="created_date"
                    // min={new Date().toISOString().split("T")[0]} 
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.created_date}
                  />
                  {formik.touched.created_date && formik.errors.created_date ? (
                    <div className="text-danger mt-1">
                      {formik.errors.created_date}
                    </div>
                  ) : null}
                </div>

                {/* <div className="mb-3">
                  <label className="form-label">Initial Process <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    type="text"
                    id="initial_process"
                    name="initial_process"
                    value={formik.values.initial_process}
                    readOnly
                  />
                </div> */}

                <div className="mb-3">
                  <label className="form-label">Process Start Date <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    type="date"
                    id="process_start_date"
                    name="process_start_date"
                    // min={new Date().toISOString().split("T")[0]} 
                    onChange={formik.handleChange}
                    value={formik.values.process_start_date}

                  />
                  {formik.touched.process_start_date && formik.errors.process_start_date ? (
                    <div className="text-danger mt-1">{formik.errors.process_start_date}</div>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label className="form-label">Staff Name</label>
                  <input
                    className="form-control"
                    type="text"
                    id="staff_name"
                    name="staff_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.staff_name}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Seed Variety</label>
                  <input
                    className="form-control"
                    type="text"
                    id="seed_variety"
                    name="seed_variety"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.seed_variety}
                  />
                </div>

                {/* <div className="mb-3">
                  <label className="form-label">Supplier</label>
                  <input
                    className="form-control"
                    type="text"
                    id="supplier"
                    name="supplier"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.supplier}
                  />
                </div> */}


                <div className="mt-4">
                  <button type="button" className="btn btn-primary w-md" onClick={closeModal} style={{ marginRight: "2px" }}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary w-md">
                    Submit
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Change Stage
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label className="fw-medium">
              New Stage <span className="text-danger">*</span>
            </Label>
            <Input
              type="select"
              value={newStage?.pk_process_key || ""}
              onChange={e => {
                const process = processList.find(p => p.pk_process_key === e.target.value);
                if (!process) return;

                const matchingSeq = sequenceList.find(
                  s => s.fk_process_key === process.pk_process_key
                );

                setNewStage({
                  ...process,
                  pk_sequence_key: matchingSeq ? matchingSeq.pk_sequence_key : null,
                  process_position: matchingSeq ? matchingSeq.process_position : null
                });
              }}

            >
              <option value="">Select Process</option>

              {processList.map(proc => (
                <option key={proc.pk_process_key} value={proc.pk_process_key}>
                  {proc.process_name} (Process Position: {proc.process_position})
                </option>
              ))}
            </Input>

          </div>
          <div className="alert alert-info mb-0">
            <i className="mdi mdi-information-outline me-2"></i>
            Progress will be automatically updated based on the selected stage for all bags in the batch.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleStageChange}>
            Update Stage
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
